function addLogo() {
    setTimeout(()=>{
        const logos1 = document.querySelector(".sk-login-logo-img");
        if(logos1){
            logos1.src="/resources/definition/generic/Resources/en/us/protego_logo__1666162307000.png";
        }
    }
    , 1000);
};

export { addLogo };